var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('ColorsDoItBeautifulSection'),_c('ColorsConceptSection'),_c('ColorsMainPalleteSection'),_c('ColorsGradientsSection'),_c('ColorsForTextSection'),_c('ColorsCodesSection'),_c('ColorsGridWhatNotToDo'),_c('ColorsGridUsageExamplesSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }